// This component is responsible for the actual routing
import {ScrollRestoration, useNavigate} from 'react-router';
// import HeaderOrganism from "../components/header/Header";
// import useSubscribeAccounts from "../hooks/useSubscribeAccounts";
import {AvatarMenu} from '@coolcolduk/ui-mui';
import {Container, Grid} from '@mui/material';
import {PropsWithChildren} from 'react';
import {UserAccount} from '../__generated__/resolvers-types';
import ContactUs from '../components/contactUs/ContactUs';
import EtsyAccountLinkDialog from '../components/etsyAccountLinkDialog/EtsyAccountLinkDialog';
import FloatingSearch from '../components/floatingSearch/FloatingSearch';
import {getFeatures} from '../features';
import useEtsyAccountLinkDialog from '../hook/useEtsyAccountLinkDialog';
import {createAvatarMenu} from '../variables/createAvatarMenu';

export interface AppLayoutProps {
  user: UserAccount | null | undefined;
}

export default function AppLayout({user, children}: PropsWithChildren<AppLayoutProps>) {
  const navigate = useNavigate();
  const {showDialog, handleCloseDialog, handleAccountLinked} = useEtsyAccountLinkDialog(user);

  const features = getFeatures(user);

  if (!user) {
    return <>{children}</>;
  }

  return (
    <Container maxWidth="md" sx={{minHeight: '100vh', overflow: 'auto'}}>
      <Grid container direction="row" wrap="nowrap">
        {/* {user && user && <Sidebar user={user} />} */}
        {user && (
          <FloatingSearch
            mainOptions={features}
            handleOptionSelect={(v) => {
              if (!v) return;
              const feature = Object.values(features).find((f) => f.title === v);
              if (feature) navigate(feature.path);
            }}
            handleHomeButton={() => navigate('/')}
          />
        )}
        <Grid sx={{flexGrow: 1}}>
          {/* <HeaderComponent user={user} /> */}
          <Container sx={{pt: user ? 18 : 8, pb: 8, minHeight: '80vh'}}>
            <ScrollRestoration />
            {children}
          </Container>
          {/* {!user && <Footer />} */}
        </Grid>
        {user && (
          <AvatarMenu
            label={user.displayName}
            items={createAvatarMenu(user, navigate)}
            sx={{
              position: 'fixed',
              bottom: 16,
              left: 16,
              '& .MuiTypography-root': {pl: 2},
              '> button': {borderRadius: '10%'},
            }}
            avatarSrc={user.photoURL}
            avatarAlt={user.displayName}
            verticalAnchor="bottom"
            horizontalAnchor="right"
            verticalTransform="bottom"
            horizontalTransform="left"
          />
        )}
        <ContactUs user={user} />
      </Grid>

      {/* Etsy Account Link Dialog - only show when user has no linked Etsy accounts */}
      {user && showDialog && (
        <EtsyAccountLinkDialog
          open={showDialog}
          onClose={handleCloseDialog}
          onAccountLinked={handleAccountLinked}
          user={user}
        />
      )}
    </Container>
  );
}
